import { useMemo } from "react";
import usePluggableCommands from "views/components/searchbar/queryinput/usePluggableCommands";
const PluggableCommands = ({ children, usage }) => {
  const customCommands = usePluggableCommands(usage);
  return useMemo(() => children(customCommands), [children, customCommands]);
};
export default PluggableCommands;
